import { render, staticRenderFns } from "./MerchantCompanyEditPage.vue?vue&type=template&id=6d9a8dc8"
import script from "./MerchantCompanyEditPage.vue?vue&type=script&lang=js"
export * from "./MerchantCompanyEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports